(function (window, document, $) {

    $(document).ready(function () {
        // Go to url ===============================================================================================

        $('[data-goto-url]').on('click', function(e) {
            if(e.target != this) {
                return; // only continue if the target itself has been clicked
            }

            var url = $(this).data('goto-url');
            if(url) {
                window.location.href = url;
            }
        });
    });

}(window, document, jQuery));
